import { Box } from '@mui/material';

/**
 * 「サポート体制」セクションの線画。
 *
 * SolveTileArt と同じ方針で、写真やラスター画像ではなくインラインSVGにしている。
 *  - 画像リクエストを増やさない（LCPに効く）
 *  - 配色をブランドカラーの定数だけで揃えられる
 *  - 拡大しても線が潰れない
 * 装飾なので aria-hidden。意味はセクションの見出しとリード文が担う。
 */

const TEAL = '#2aa1af'; // OHANA AI のブランドカラー
const PALE = '#e2f2f3'; // ティールの淡色（面の塗り）

/** サポート体制：ヘッドセットの担当者を中央に、両脇にスタッフを並べた3人の絵 */
export const ArtSupportTeam = () => (
    <Box
        component="svg"
        viewBox="0 0 240 118"
        role="presentation"
        aria-hidden="true"
        sx={{ width: '100%', height: 'auto', display: 'block' }}
    >
        <g fill="none" stroke={TEAL} strokeWidth={4} strokeLinecap="round" strokeLinejoin="round">
            {/* 接地線 */}
            <path d="M16 108 h208" strokeWidth={3} opacity={0.45} />

            {/* 左：書類を持つスタッフ */}
            <g>
                <path d="M22 108 v-14 a26 26 0 0 1 52 0 v14" fill={PALE} />
                <circle cx="48" cy="44" r="17" fill="#fff" />
                <rect x="10" y="72" width="26" height="32" rx="4" fill="#fff" transform="rotate(-10 23 88)" />
                <path d="M14 82 h16 M13 91 h16" strokeWidth={3} transform="rotate(-10 23 88)" />
            </g>

            {/* 中央：ヘッドセットをつけた担当者 */}
            <g>
                <path d="M91 108 v-16 a29 29 0 0 1 58 0 v16" fill={PALE} />
                <path d="M129 64 l-9 10 l-9 -10" strokeWidth={3} />
                <circle cx="120" cy="40" r="19" fill="#fff" />
                <path d="M97 40 a23 23 0 0 1 46 0" />
                <rect x="92" y="38" width="10" height="17" rx="5" fill={PALE} />
                <rect x="138" y="38" width="10" height="17" rx="5" fill={PALE} />
                <path d="M97 55 a13 13 0 0 0 8 10" strokeWidth={3} />
                <circle cx="107" cy="65" r="4" fill={PALE} strokeWidth={3} />
            </g>

            {/* 右：ノートPCで対応するスタッフ */}
            <g>
                <path d="M166 108 v-14 a26 26 0 0 1 52 0 v14" fill={PALE} />
                <circle cx="192" cy="44" r="17" fill="#fff" />
                <rect x="202" y="72" width="30" height="21" rx="3" fill="#fff" />
                <path d="M198 99 h38" strokeWidth={3} />
            </g>
        </g>
    </Box>
);
